var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-in-row",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#13CBCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5501 15.8332C28.3517 15.8332 28.1767 15.9382 28.0717 16.1015L27.9901 16.2765L21.9467 29.8682C21.7601 30.2065 21.6434 30.5799 21.6434 30.9882C21.6434 32.2832 22.6934 33.3332 23.9884 33.3332C25.1084 33.3332 26.0534 32.5399 26.2751 31.4782L26.2867 31.4432L29.1334 16.4165C29.1334 16.0899 28.8767 15.8332 28.5501 15.8332ZM11.1667 20.4999L13.5001 22.8332C16.8601 19.4732 21.4217 18.0732 25.7851 18.6099L27.1734 15.4832C21.5384 14.4799 15.5301 16.1482 11.1667 20.4999ZM34.5001 22.8332L36.8334 20.4999C34.9201 18.5865 32.6917 17.2099 30.3117 16.3349L29.6934 19.6249C31.4434 20.3482 33.0767 21.4099 34.5001 22.8332ZM29.8334 27.4999L32.1667 25.1665C31.2334 24.2332 30.1834 23.5099 29.0634 22.9615L28.4217 26.3682C28.9117 26.6832 29.3901 27.0565 29.8334 27.4999ZM15.8334 25.1665L18.1667 27.4999C19.4851 26.1815 21.1534 25.4115 22.8684 25.1665L24.3617 21.8065C21.2934 21.7132 18.1784 22.8215 15.8334 25.1665Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.43f09fd8.svg";
export { ForwardRef as ReactComponent };